import { render, staticRenderFns } from "./SearchRedirect.vue?vue&type=template&id=086f033e&"
import script from "./SearchRedirect.vue?vue&type=script&lang=js&"
export * from "./SearchRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports